//@vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');
const ceil = require('lodash/math/ceil');
const { handleActions, combineActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../../actions/contractEasyLoan');
//@helpers
const { decimalsLength, parseSpanishNumberToFloat } = require('utilities/currencyHelper');
//@constant
const { PAYMENT_DAY_OTHER } = require('../../loansConstants/index').contractEasyLoan;
//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const {
    EURO_TEXT,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    WIZARD_FOURTH_STEP } = require('constants/index');

const setInitialState = () => Immutable.fromJS({
    steps: [
        { valid: false },
        { valid: false },
        { hasSignaturePattern: true },
    ],
    twoSteps: [
        { valid: false },
        { hasSignaturePattern: true },
    ],
    fourSteps: [
        { valid: false },
        { valid: false },
        { valid: false },
        { hasSignaturePattern: true },
    ],
    visibleStep: WIZARD_FIRST_STEP,
    beforeStep: 0,
    isFetching: false,
    isFetchingInstallment: false,
    isFetchingMinInstallmentQuantity: false,
    isFetchingDocuments: !__CONTACT_CENTER__, // We don´t fetch documents in CC - the PDF viewer is hidden
    isFetchingZip: false,
    submitSuccessful: false,
    willCancel: false,
    error: false,
    fetchingTotalAmount: false,
    amountDefaultLimit: 0,
    maxAmount: 0,
    minAmount: 0,
    maxAmountError: false,
    minTae: 0,
    maxTae: 0,
    aniversaryStandard: '',
    aniversarySubtype: '',
    aniversaryType: '',
    currency: EURO_TEXT,
    showPurposeError: false,
    openingCommission: {},
    selectedAmount: 0,
    selectedPurpose: '',
    selectedTerm: 0,
    standard: '',
    stepReady: false,
    totalAmount: 0,
    subtype: '',
    tae: 0,
    termDefaultLimit: 0,
    maxTerm: 0,
    minTerm: 0,
    notAvailable: false,
    tin: 0,
    type: '',
    installment: {
        amount: 0,
        currency: EURO_TEXT,
        decimalsLength: 0
    },
    fetchingProposition: false,
    selectedAccount: '',
    errorSelectedAccount: false,
    fechaFinCarencia: '',
    fechaAmortiz: '',
    propositionNumber: '',
    propositionYear: '',
    contractNumber: '',
    paymentDaySelected: PAYMENT_DAY_OTHER,
    vencDate: '',
    agreeCheckbox: false,
    agreeIneCheckbox: false,
    showErrorMessage: false,
    hasSignaturePattern: true,
    downloadDocumentsError: false,
    documents: null,
    errorDocuments: false,
    isFetchingPrintDocuments: false,
    timestampCheckbox: null,
    timestampIneCheckbox: null,
    hasEasyLoanSuccess: null,
    isFetchingINEDocument: false,
    errorEasyLoanIneDocument: false,
    fileEasyLoanIneDocumentId: null,
    fileEasyLoanIneDocument: null,
    isFetchingPolicyDocuments: false,
    errorEasyLoanPolicyDocument: false,
    fileEasyLoanPolicyDocumentId: null,
    fileEasyLoanPolicyDocument: null,
    isEasyLoanEmailSent: false,
    officePrintStepThree: false,
    officePrintStepFour: false,
    initAPIFlag: false,
    mailAPIFlag: false,
    checkboxFlag: false,
    btnFlag: false,
    firstSelectedAccount: null,
    firstSelectedAmount: null,
    firstSelectedPurpose: null,
    firstSelectedTerm: null,
    firstPaymentDaySelected: null,
    scrollDownPolicy: false


});

const processOpeningCommission = (openingCommissionPercentage, openingCommissionMin, loanAmount) => {

    let openingCommissionAmount = loanAmount * openingCommissionPercentage / 100;

    if (openingCommissionMin > openingCommissionAmount) {
        openingCommissionAmount = openingCommissionMin;
    }

    return {
        minimum: openingCommissionMin,
        percentage: openingCommissionPercentage,
        amount: openingCommissionAmount,
        showPercentajeCommission: !(openingCommissionMin !== 0 && openingCommissionPercentage === 0),
        showMinCommission: openingCommissionMin !== 0
    };
};

const processMinInstallmentQuantity = (minInstallmentQuantity) => {
    const roundedValue = ceil(minInstallmentQuantity);
    if (roundedValue > 60) {
        return 60;
    } else if (roundedValue < 12) {
        return 12;
    } else {
        return roundedValue;
    }
}

const processInstallmentResponse = (state, response) => {
    return state.mergeDeep({
        isFetchingInstallment: false,
        tae: response.tae,
        indCapson: get(response, 'indCapson') || '',
        installment: {
            amount: get(response, 'importePriCuota.importe'),
            currency: get(response, 'importePriCuota.divisa'),
            decimalsLength: decimalsLength(get(response, 'importePriCuota.importe'))
        }
    });
};

const initialize = (state, segmentedLoan) => {
    const rawAmountMax = get(segmentedLoan, 'importeMaximo') || 0;
    const rawAmountMin = get(segmentedLoan, 'importeMinimo') || 0;
    const rawQuotaLimit = get(segmentedLoan, 'limiteCuota') || 0;
    const rawOpeningCommission = get(segmentedLoan, 'comisionApertura') || 0;
    const rawOpeningCommissionMin = get(segmentedLoan, 'comisionAperturaMin') || 0;
    const maxTerm = parseInt(get(segmentedLoan, 'plazoMaximo')) || 0;
    const defaultTermMin = parseInt(get(segmentedLoan, 'plazoMinimo')) || 0;

    const openingCommissionData = parseSpanishNumberToFloat(rawOpeningCommission);
    const openingCommissionMin = parseSpanishNumberToFloat(rawOpeningCommissionMin);
    const maxAmount = parseSpanishNumberToFloat(rawAmountMax);
    const minAmount = parseSpanishNumberToFloat(rawAmountMin);
    const maxAmountError = minAmount > maxAmount;
    const selectedAmount = state.get('selectedAmount') !== 0 ? state.get('selectedAmount') : maxAmount;
    const selectedTerm = state.get('selectedTerm') !== 0 ? state.get('selectedTerm') : maxTerm;
    
    return state.merge({
        currency: get(segmentedLoan, 'divisa', EURO_TEXT),
        maxAmount,
        minAmount,
        maxAmountError,
        maxTerm,
        minTerm: defaultTermMin,
        minTae: get(segmentedLoan, 'minTae', 0),
        maxTae: get(segmentedLoan, 'maxTae', 0),
        defaultTermMin,
        quotaLimit: parseSpanishNumberToFloat(rawQuotaLimit),
        selectedAmount,
        selectedTerm,
        tin: parseSpanishNumberToFloat(get(segmentedLoan, 'tipoNominal')) || 0,
        type: get(segmentedLoan, 'tipo') || '',
        subtype: get(segmentedLoan, 'subtipo') || '',
        standard: get(segmentedLoan, 'standard') || '',
        aniversaryType: get(segmentedLoan, 'tipoPagoAniversario') || '',
        aniversarySubtype: get(segmentedLoan, 'subtipoPagoAniversario') || '',
        aniversaryStandard: get(segmentedLoan, 'erPagoAniversario') || '',
        openingCommission: processOpeningCommission(openingCommissionData, openingCommissionMin, maxAmount),
        stepReady: true,
        isFetching: false,
        hasEasyLoanSuccess: true,
    });
};

const validateStep = (state, action) => {
    const selectSteps = action.payload.newEasyLoanFeatureFlag && ( !__CONTACT_CENTER__ || isPrintOfficeMode()) ? 'fourSteps' : 'steps';
    switch (action.payload.step) { //This could be an if eventually - Leave it for consistency only.
        case WIZARD_FIRST_STEP:
            const emptyPurposeMessage = !!state.get('selectedPurpose');
            const isValid = !state.get('isFetchingInstallment') &&
                !state.get('isFetchingMinInstallmentQuantity') && emptyPurposeMessage && !(state.get('errorAsnef') || state.get('error'));
            return state.setIn([selectSteps, FIRST_STEP, 'valid'], isValid)
                .merge({
                    firstSelectedPurpose: state.get('selectedPurpose'),
                    firstSelectedAmount: state.get('selectedAmount'),
                    firstSelectedTerm: state.get('selectedTerm'),
                    showPurposeError: !emptyPurposeMessage,
                    visibleStep: isValid ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP,
                    beforeStep: isValid ? state.get('visibleStep') : state.get('beforeStep')
                });

        case WIZARD_SECOND_STEP:
            const valid = !!state.get('selectedAccount');
            return state.setIn([selectSteps, SECOND_STEP, 'valid'], valid)
                .merge({
                    firstSelectedAccount: state.get('selectedAccount'),
                    firstPaymentDaySelected: state.get('paymentDaySelected'),
                    errorSelectedAccount: !valid,
                    visibleStep: valid ? WIZARD_THIRD_STEP : WIZARD_SECOND_STEP,
                    beforeStep: valid ? state.get('visibleStep') : state.get('beforeStep'),
                    errorAsnef: undefined,
                    agreeCheckbox: state.get('agreeCheckbox'),
                    showErrorMessage: false,
                });
        case WIZARD_THIRD_STEP:
            const checkboxValue = isPrintOfficeMode() && action.payload.newEasyLoanFeatureFlag ? state.get('officePrintStepThree') : action.payload.newEasyLoanFeatureFlag ? state.get('agreeIneCheckbox') : state.get('agreeCheckbox');
            return state.setIn([selectSteps, THIRD_STEP, 'valid'], checkboxValue)
                .merge({
                    showErrorMessage: !checkboxValue,
                    isFetching: false,
                    visibleStep: checkboxValue ? WIZARD_FOURTH_STEP : WIZARD_THIRD_STEP,
                    beforeStep: checkboxValue ? state.get('visibleStep') : state.get('beforeStep'),
                });
        default:
            return state;
    }
}

const mapPropositionNumber = (state, action) => {
    const { response } = action.payload;
    return state.merge({
        ...response,
        fetchingProposition: false
    });
}

const contractEasyLoanReducer = handleActions(
    {
        [simpleActions.contractEasyLoanAsnef]: state =>
            state.set('isFetching', true),
        [simpleActions.contractEasyLoanAsnefError]: state =>
            state.merge({
                isFetching: false,
                error: true
            }),
        [simpleActions.contractEasyLoanAsnefFailure]: state =>
            state.merge({
                isFetching: false,
                errorAsnef: true
            }),
        [simpleActions.contractEasyLoanAsnefSuccess]: (state, action) => {
            const selectSteps = action.payload.newEasyLoanFeatureFlag ? 'fourSteps' : 'steps';
            const emptyPurposeMessage = !!state.get('selectedPurpose');
            const isValid = !state.get('isFetchingInstallment') &&
                !state.get('isFetchingMinInstallmentQuantity') && emptyPurposeMessage;

            return state.setIn([selectSteps, FIRST_STEP, 'valid'], isValid)
                .merge({
                    showPurposeError: !emptyPurposeMessage,
                    isFetching: false,
                    errorAsnef: false,
                    visibleStep: isValid ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP,
                    beforeStep: isValid ? state.get('visibleStep') : state.get('beforeStep')
                });
        },
        [simpleActions.contractEasyLoanDownloadDocument]: state =>
            state.set('isFetchingZip', true),
        [simpleActions.contractEasyLoanDownloadDocumentError]: state =>
            state.merge({
                isFetchingZip: false,
                downloadDocumentsError: true
            }),
        [simpleActions.contractEasyLoanDownloadDocumentSuccess]: state =>
            state.merge({
                isFetchingZip: false,
                downloadDocumentsError: false
            }),
        [simpleActions.contractEasyLoanFormalize]: state =>
            state.merge({
                isFetching: true,
                error: false,
                submitSuccessful: false
            }),
        [simpleActions.contractEasyLoanFormalizeError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanFormalizeSuccess]: state =>
            state.set('submitSuccessful', true),
        [simpleActions.contractEasyLoanGetProposition]: state =>
            state.set('fetchingProposition', true),
        [simpleActions.contractEasyLoanGetPropositionError]: state =>
            state.set('fetchingProposition', false),
        [simpleActions.contractEasyLoanGetPropositionSuccess]: (state, action) =>
            mapPropositionNumber(state, action),
        [simpleActions.contractEasyLoanGetTotalImport]: state =>
            state.set('fetchingTotalAmount', true),
        [simpleActions.contractEasyLoanGetTotalImportError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanGetTotalImportSuccess]: (state, action) =>
            state.merge({
                fetchingTotalAmount: false,
                totalAmount: action.payload.totalAmount
            }),
        [simpleActions.contractEasyLoanHiringDocuments]: state =>
            state.merge({
                isFetchingDocuments: true,
                errorDocuments: false
            }),
        [simpleActions.contractEasyLoanHiringDocumentsError]: state =>
            state.merge({
                isFetchingDocuments: false,
                errorDocuments: true
            }),
        [simpleActions.contractEasyLoanHiringDocumentsSuccess]: (state, action) =>
            state.merge({
                isFetchingDocuments: false,
                documents: action.payload.response,
                errorDocuments: false
            }),
        [simpleActions.contractEasyLoanInstallment]: state =>
            state.set('isFetchingInstallment', true),
        [simpleActions.contractEasyLoanInstallmentError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanInstallmentSuccess]: (state, action) =>
            processInstallmentResponse(state, action.payload.response),
        [simpleActions.contractEasyLoanMinInstallment]: state =>
            state.set('isFetchingMinInstallmentQuantity', true),
        [simpleActions.contractEasyLoanMinInstallmentError]: state =>
            state.merge({
                minTerm: state.get('defaultTermMin'),
                maxTerm: state.get('maxTerm'),
                isFetchingMinInstallmentQuantity: false
            }),
        [simpleActions.contractEasyLoanMinInstallmentSuccess]: (state, action) =>
            state.merge({
                minTerm: processMinInstallmentQuantity(action.payload.minimumInstallmentQuantity),
                maxTerm: state.get('maxTerm'),
                isFetchingMinInstallmentQuantity: false
            }),
        [simpleActions.contractEasyLoanNotAvailable]: state =>
            state.merge({
                notAvailable: true,
                stepReady: false,
                hasEasyLoanSuccess: false,
            }),
        [simpleActions.contractEasyLoanPreFill]: state =>
            state.set('isFetching', true),
        [simpleActions.contractEasyLoanOfficeInePrint]: state =>
            state.set('officePrintStepThree', true),
        [simpleActions.officePrintReset]: (state, action) =>
            state.merge({
                officePrintStepThree: !!action.payload.officePrintStepThree ? true : false,
                officePrintStepFour: !!action.payload.officePrintStepThree ? true : false,
            }),
        [simpleActions.contractEasyLoanOfficeContractPrint]: state =>
            state.set('officePrintStepFour', true),
        [simpleActions.contractEasyLoanPreFillError]: state =>
            state.set('error', true),
        [simpleActions.contractEasyLoanPreFillSuccess]: (state, action) =>
            initialize(state, action.payload),
        [simpleActions.contractEasyLoanResetStep]: state =>
            state.mergeDeep(Object.assign({}, setInitialState(), { stepReady: true })),
        [simpleActions.contractEasyLoanSetAccount]: (state, action) =>
            state.merge({
                selectedAccount: action.payload.accountId,
                errorSelectedAccount: false
            }),
        [simpleActions.contractEasyLoanSetLoanAmount]: (state, action) => {
            const openingCommissionData = state.get('openingCommission');
            const openingCommission = processOpeningCommission(openingCommissionData.get('percentage'), openingCommissionData.get('minimum'), action.payload.selectedAmount);

            return state.merge({
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: state.get('maxTerm'), // Bussiness Rule: we always set the terms slider to top when changing the selectedAmount.
                openingCommission
            });
        },
        [simpleActions.contractEasyLoanSetPurpose]: (state, action) =>
            state.merge({
                showPurposeError: false,
                selectedPurpose: action.payload.purpose
            }),
        [simpleActions.contractEasyLoanSetPaymentDay]: (state, action) =>
            state.set('paymentDaySelected', action.payload.paymentDay),
        [simpleActions.contractEasyLoanSetStep]: (state, action) =>
            state.set('visibleStep', action.payload.visibleStep),
        [simpleActions.contractEasyLoanSetTerm]: (state, action) =>
            state.set('selectedTerm', action.payload.term),
        [simpleActions.contractEasyLoanToggleAgreeCheckbox]: state =>
            state.merge({
                agreeCheckbox: !state.get('agreeCheckbox'),
                showErrorMessage: false,
                timestampCheckbox: new Date().getTime(),
            }),
        [simpleActions.contractEasyLoanIneToggleAgreeCheckbox]: state =>
            state.merge({
                agreeIneCheckbox: !state.get('agreeIneCheckbox'),
                showErrorMessage: false,
                timestampIneCheckbox: new Date().getTime(),
            }),
        [simpleActions.contractEasyLoanAgreeReset]: (state) =>
            state.merge({
                agreeIneCheckbox: false,
                showErrorMessage: false
            }),
        [simpleActions.payrollLoanRequestEmailPrecontractual]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: true,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.payrollLoanRequestEmailPrecontractualSuccess]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: true,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.payrollLoanRequestEmailPrecontractualError]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: true,
            }),
        [simpleActions.contractEasyLoanValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.contractEasyLoanWillLeave]: () =>
            setInitialState(),
        [simpleActions.contractEasyLoanDownloadPrintDocument]: state =>
            state.set('isFetchingPrintDocuments', true),
        [combineActions(
            simpleActions.contractEasyLoanDownloadPrintDocumentError,
            simpleActions.contractEasyLoanDownloadPrintDocumentSuccess
        )]: state =>
                state.set('isFetchingPrintDocuments', false),
        [simpleActions.getEasyLoanIneDocument]: (state) =>
            state.merge({
                isFetchingINEDocument: true,
                errorEasyLoanIneDocument: false
            }),
        [simpleActions.getEasyLoanIneDocumentSuccess]: (state, action) =>
            state.merge({
                fileEasyLoanIneDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileEasyLoanIneDocumentId: action.payload.documentId,
                errorEasyLoanIneDocument: false,
                isFetchingINEDocument: false
            }),
        [simpleActions.getEasyLoanIneDocumentError]: (state) =>
            state.merge({
                errorEasyLoanIneDocument: true,
                isFetchingINEDocument: false
            }),
        [simpleActions.getEasyLoanPolicyDocument]: (state) =>
            state.merge({
                isFetchingPolicyDocuments: true,
                errorEasyLoanPolicyDocument: false
            }),
        [simpleActions.getEasyLoanPolicyDocumentSuccess]: (state, action) =>
             state.merge({
                fileEasyLoanPolicyDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileEasyLoanPolicyDocumentId: action.payload.documentId,
                errorEasyLoanPolicyDocument: false,
                isFetchingPolicyDocuments: false
            }),
        [simpleActions.getEasyLoanPolicyDocumentError]: (state) =>
            state.merge({
                errorEasyLoanPolicyDocument: true,
                isFetchingPolicyDocuments: false
            }),
        [simpleActions.contractEasyLoanEmailSuccess]: state =>
            state.merge({
                isEasyLoanEmailSent: true,
                isEasyLoanEmailError: false
            }),
        [simpleActions.contractEasyLoantEmailError]: state =>
            state.merge({
                isEasyLoanEmailSent: false,
                isEasyLoanEmailError: true
            }),
        [simpleActions.resetMailSent]: state =>
            state.merge({
                isEasyLoanEmailSent: false,
                isEasyLoanEmailError: false,
            }),
        [simpleActions.contractEasyLoanInitLoading]: state =>
            state.merge({
                isEasyLoanEmailInitError: false,
                isEasyLoanEmailInitSuccess: false
            }),
        [simpleActions.contractEasyLoanInitOneSuccess]: (state, action) =>
            state.merge({
                isEasyLoanEmailInitError: false,
                isEasyLoanEmailInitSuccess: true,
                operationProcessIdINE: action.payload.operationProcessIdINE
            }),
        [simpleActions.contractEasyLoanInitTwoSuccess]: (state, action) =>
            state.merge({
                isEasyLoanEmailInitError: false,
                isEasyLoanEmailInitSuccess: true,
                operationProcessIdPolicy: action.payload.operationProcessIdPolicy
            }),
        [simpleActions.contractEasyLoanInitError]: state =>
            state.merge({
                isEasyLoanEmailInitError: true,
                isEasyLoanEmailInitSuccess: false
            }),
        [simpleActions.setInitApiFlag]: (state, action) =>
            state.merge({
                initAPIFlag: action.payload.initAPIFlag,
                mailAPIFlag: action.payload.mailAPIFlag,
                checkboxFlag: action.payload.checkboxFlag,
                btnFlag: action.payload.btnFlag
            }),
        [simpleActions.contractEasyLoanScrollDowPolicy]: (state, action) =>
            state.merge({
                scrollDownPolicy: true
            }),
    },
    setInitialState()
);

module.exports = contractEasyLoanReducer;
module.exports.setInitialState = setInitialState;
